import React from "react";
import "./SeamlessIntegration.css";

const SeamlessIntegration = () => {
    return (
        <section className="seamless-section">
            {/* Visual Header - Split View Simulation */}
            <div className="seamless-visuals">
                {/* Placeholder for split image effect */}
                <div className="seamless-image-container">
                    <img src="/images/image2.webp" alt="3ds Max Wireframe" className="seamless-img-left" />
                    <img src="/images/image1.webp" alt="Rendered View" className="seamless-img-right" />

                    {/* Center Split Icon/Handle */}
                    <div className="seamless-split-handle">
                        <span>&lt;&nbsp;&gt;</span>
                    </div>
                </div>
            </div>

            {/* Text Content */}
            <div className="seamless-content">
                <h2>
                    Seamlessly integrates into<br />
                    your current workflow
                </h2>

                <p className="seamless-description">
                    No need to model in gaming engines or spend time learning unity or unreal.
                    Just model in 3ds Max and we take care of the rest.
                </p>

                <ul className="seamless-features">
                    <li>No restrictive hotspots</li>
                    <li>No laggy streaming</li>
                    <li>No gaming engines</li>
                    <li>No complicated workflows</li>
                </ul>
            </div>
        </section>
    );
};

export default SeamlessIntegration;
